import _asyncToGenerator from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _regeneratorRuntime from "/usr/src/app/node_modules/@babel/runtime/regenerator/index.js";
import { ExtensionMessage } from './models/extensionMessage.js';
import { ExtensionMessageType } from "./models/extensionMessageType.js";
import { PaymentExtensionResult } from './models/paymentExtensionResult.js';
import { RestClient } from './restClient.js';
export var PaymentExtensions = /*#__PURE__*/function () {
  function PaymentExtensions(shop, basketId, imagineEnvironmentBaseUrl) {
    var authToken = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
    var getNewAuthTokenFunction = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
    var customRequestHeaders = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;

    _classCallCheck(this, PaymentExtensions);

    this.shop = shop;
    this.basketId = basketId;
    this.messageChannels = [];
    this.shop = shop;
    this.basketId = basketId;
    this.client = new RestClient(imagineEnvironmentBaseUrl, shop, authToken, getNewAuthTokenFunction, customRequestHeaders);
  }

  _createClass(PaymentExtensions, [{
    key: "initiatePayment",
    value: function () {
      var _initiatePayment = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(iframe) {
        var _this = this;

        var paymentExtension, messageChannel, extensionRunningPromise, errorMsg;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                if (iframe) {
                  _context.next = 3;
                  break;
                }

                throw new Error('No valid iframe provided!');

              case 3:
                _context.next = 5;
                return this.getPaymentExtension();

              case 5:
                paymentExtension = _context.sent;
                messageChannel = new MessageChannel();
                extensionRunningPromise = new Promise(function (resolve) {
                  _this.messageChannels.push(messageChannel);

                  messageChannel.port1.onmessage = function (event) {
                    _this.onMessageReceived(event.data, paymentExtension, resolve);
                  };
                });
                iframe.addEventListener('load', function initiateHandshake() {
                  var _a;

                  var handshakeMessage = new ExtensionMessage(ExtensionMessageType.Handshake, paymentExtension.encryptedPaymentExtension);
                  var targetOrigin = new URL(paymentExtension.url).origin;
                  (_a = this.contentWindow) === null || _a === void 0 ? void 0 : _a.postMessage(handshakeMessage, targetOrigin, [messageChannel.port2]);
                }, {
                  once: true
                });
                iframe.src = paymentExtension === null || paymentExtension === void 0 ? void 0 : paymentExtension.url;
                iframe.title = paymentExtension === null || paymentExtension === void 0 ? void 0 : paymentExtension.name;
                return _context.abrupt("return", extensionRunningPromise);

              case 14:
                _context.prev = 14;
                _context.t0 = _context["catch"](0);
                errorMsg = 'Failed to initiate payment extension';
                console.error(errorMsg, _context.t0);
                return _context.abrupt("return", new Promise(function (resolve) {
                  return resolve(new PaymentExtensionResult(false, errorMsg, ''));
                }));

              case 19:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 14]]);
      }));

      function initiatePayment(_x) {
        return _initiatePayment.apply(this, arguments);
      }

      return initiatePayment;
    }()
  }, {
    key: "getPaymentExtension",
    value: function getPaymentExtension() {
      return this.client.get("PaymentExtension/paymentExtension/".concat(this.basketId));
    }
  }, {
    key: "disposeMessageListeners",
    value: function disposeMessageListeners() {
      if (this.messageChannels && this.messageChannels.length > 0) {
        this.messageChannels.forEach(function (messageChannel) {
          messageChannel.port1.close();
          messageChannel.port2.close();
        });
      }
    }
  }, {
    key: "onMessageReceived",
    value: function onMessageReceived(message, paymentExtension, resolve) {
      try {
        switch (message.type) {
          case ExtensionMessageType.PaymentResponse:
            this.processResponse(paymentExtension, message.encryptedPayload, resolve);
            break;

          default:
            throw new Error("Unsupported message type ".concat(message.type, " received!"));
        }
      } catch (e) {
        console.error(e.message, e);
        this.disposeMessageListeners();
      }
    }
  }, {
    key: "processResponse",
    value: function () {
      var _processResponse = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(paymentExtension, encryptedPayload, resolve) {
        var paymentExtensionResponse, success;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                paymentExtensionResponse = {
                  basketId: this.basketId,
                  paymentExtensionId: paymentExtension.id,
                  moduleAuthId: paymentExtension.moduleAuthId,
                  shop: this.shop,
                  encryptedResult: encryptedPayload
                };
                _context2.next = 3;
                return this.postPaymentExtensionResponse(paymentExtensionResponse);

              case 3:
                success = _context2.sent;
                this.disposeMessageListeners();
                resolve(success);

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function processResponse(_x2, _x3, _x4) {
        return _processResponse.apply(this, arguments);
      }

      return processResponse;
    }()
  }, {
    key: "postPaymentExtensionResponse",
    value: function () {
      var _postPaymentExtensionResponse = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(paymentExtensionResponse) {
        var errorMsg;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return this.client.postData('PaymentExtension/paymentExtension', paymentExtensionResponse);

              case 3:
                return _context3.abrupt("return", _context3.sent);

              case 6:
                _context3.prev = 6;
                _context3.t0 = _context3["catch"](0);
                errorMsg = 'Failed to post payment extension response';
                console.error(errorMsg, _context3.t0);
                return _context3.abrupt("return", new Promise(function (resolve) {
                  return resolve(new PaymentExtensionResult(false, errorMsg, ''));
                }));

              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 6]]);
      }));

      function postPaymentExtensionResponse(_x5) {
        return _postPaymentExtensionResponse.apply(this, arguments);
      }

      return postPaymentExtensionResponse;
    }()
  }]);

  return PaymentExtensions;
}();